import { z } from "zod";

export const contactSchema = z.object({
  nombre: z.string().min(1, "Este campo es requerido"),
  email: z
    .string()
    .min(1, "Este campo es requerido")
    .email("Correo electrónico inválido"),
  telefono: z.string().min(1, "Este campo es requerido"),
  condominio: z.string().optional(),
});

export type ContactValues = z.infer<typeof contactSchema>;
